module.exports = [
	{
		"name": "Activities",
		"features": [
			{
				"key": "bicycle-rental",
				"display": "Bicycle rental"
			},
			{
				"key": "casino",
				"display": "Casino"
			},
			{
				"key": "fitness-center",
				"display": "Fitness center"
			},
			{
				"key": "game-room",
				"display": "Game room"
			},
			{
				"key": "golf",
				"display": "Golf"
			},
			{
				"key": "playground",
				"display": "Playground"
			},
			{
				"key": "pool-table",
				"display": "Pool\ntable"
			},
			{
				"key": "skiing-downhill",
				"display": "Skiing (downhill)"
			},
			{
				"key": "ski-inski-out",
				"display": "Ski-in/Ski-out"
			},
			{
				"key": "tennis-indoor",
				"display": "Tennis\n(indoor)"
			},
			{
				"key": "tennis-outdoor",
				"display": "Tennis (outdoor)"
			}
		]
	},
	{
		"name": "General",
		"features": [
			{
				"key": "24-hour-front-desk",
				"display": "24 hour front desk"
			},
			{
				"key": "adults-only",
				"display": "Adults only"
			},
			{
				"key": "air-conditioned",
				"display": "Air-conditioned"
			},
			{
				"key": "atm-on-site",
				"display": "ATM\non-site"
			},
			{
				"key": "balcony",
				"display": "Balcony"
			},
			{
				"key": "barlounge",
				"display": "Bar/Lounge"
			},
			{
				"key": "beachfront",
				"display": "Beachfront"
			},
			{
				"key": "cable-or-satellite-tv",
				"display": "Cable or satellite TV"
			},
			{
				"key": "coffee-shop",
				"display": "Coffee shop"
			},
			{
				"key": "complimentary-breakfast",
				"display": "Complimentary breakfast"
			},
			{
				"key": "complimentary-newspapers",
				"display": "Newspapers (free)"
			},
			{
				"key": "continental-breakfast",
				"display": "Continental breakfast"
			},
			{
				"key": "cribs-available",
				"display": "Cribs available"
			},
			{
				"key": "designated-smoking-area",
				"display": "Designated smoking area"
			},
			{
				"key": "express-check-in",
				"display": "Express Check\nIn"
			},
			{
				"key": "express-check-out",
				"display": "Express checkout"
			},
			{
				"key": "facilities-for-disabled-guests",
				"display": "Facilities for Disabled\nGuests"
			},
			{
				"key": "fireplace",
				"display": "Fireplace"
			},
			{
				"key": "gift-shop",
				"display": "Giftshop"
			},
			{
				"key": "grill",
				"display": "Grill"
			},
			{
				"key": "hot-tub",
				"display": "Hot\ntub"
			},
			{
				"key": "kitchenkitchenette",
				"display": "Kitchen/Kitchenette"
			},
			{
				"key": "laundry-facilities",
				"display": "Laundry facilities"
			},
			{
				"key": "linens",
				"display": "Linens"
			},
			{
				"key": "night-club",
				"display": "Night\nclub"
			},
			{
				"key": "non-smoking-rooms-available",
				"display": "Non-smoking rooms available"
			},
			{
				"key": "no-smoking",
				"display": "Nosmoking"
			},
			{
				"key": "pool-children",
				"display": "Pool\n(children)"
			},
			{
				"key": "pool-indoor",
				"display": "Pool (indoor)"
			},
			{
				"key": "pool-outdoor",
				"display": "Pool (outdoor)"
			},
			{
				"key": "private-beach",
				"display": "Private\nbeach"
			},
			{
				"key": "restaurant",
				"display": "Restaurant"
			},
			{
				"key": "room-service",
				"display": "Room service"
			},
			{
				"key": "safe",
				"display": "Safe"
			},
			{
				"key": "sauna",
				"display": "Sauna"
			},
			{
				"key": "ski-storage",
				"display": "Ski\nstorage"
			},
			{
				"key": "smoking-rooms-available",
				"display": "Smoking rooms available"
			},
			{
				"key": "soap-and-shampoo-provided",
				"display": "Soap and Shampoo Provided"
			},
			{
				"key": "steam-room",
				"display": "Steam\nroom"
			},
			{
				"key": "storage-available",
				"display": "Storage available"
			},
			{
				"key": "terracepatio",
				"display": "Terrace/Patio"
			},
			{
				"key": "towels",
				"display": "Towels"
			},
			{
				"key": "washerdryer-available-in-room",
				"display": "Washer/dryer available in-room"
			},
			{
				"key": "windows-open",
				"display": "Windows (opening)"
			},
			{
				"key": "winery",
				"display": "Winery"
			}
		]
	},
	{
		"name": "Internet",
		"features": [
			{
				"key": "internet-free",
				"display": "Internet (free)"
			},
			{
				"key": "internet-surcharge",
				"display": "Internet (surcharge)"
			},
			{
				"key": "wi-fi-free",
				"display": "Wi-Fi (free)"
			},
			{
				"key": "wi-fi-surcharge",
				"display": "Wi-Fi (surcharge)"
			}
		]
	},
	{
		"name": "Parking",
		"features": [
			{
				"key": "bus-parking-offsite",
				"display": "Bus Parking (offsite)"
			},
			{
				"key": "bus-parking-onsite",
				"display": "Bus Parking (onsite)"
			},
			{
				"key": "long-term-parking-free",
				"display": "Long-term parking (free)"
			},
			{
				"key": "long-term-parking-surcharge",
				"display": "Long-term parking (surcharge)"
			},
			{
				"key": "parking-free",
				"display": "Parking (free)"
			},
			{
				"key": "parking-surcharge",
				"display": "Parking (surcharge)"
			},
			{
				"key": "valet-parking-free",
				"display": "Valet parking (free)"
			},
			{
				"key": "valet-parking-surcharge",
				"display": "Valet parking (fee)"
			}
		]
	},
	{
		"name": "Policy",
		"features": [
			{
				"key": "pets-allowed-on-request-charges-may-apply",
				"display": "Pets allowed on request. Charges may apply."
			},
			{
				"key": "pets-not-allowed",
				"display": "Pets not allowed"
			}
		]
	},
	{
		"name": "Services",
		"features": [
			{
				"key": "airport-shuttle-free",
				"display": "Airport shuttle (free)"
			},
			{
				"key": "airport-shuttle-surcharge",
				"display": "Airport shuttle (surcharge)"
			},
			{
				"key": "av-equipment-rental",
				"display": "A/V equipment rental"
			},
			{
				"key": "babysittingchild-services-free",
				"display": "Babysitting/child services (free)"
			},
			{
				"key": "babysittingchild-services-surcharge",
				"display": "Babysitting/child services (surcharge)"
			},
			{
				"key": "beauty-salon",
				"display": "Beauty salon"
			},
			{
				"key": "business-center",
				"display": "Business center"
			},
			{
				"key": "car-rental",
				"display": "Car rental"
			},
			{
				"key": "childrens-programs",
				"display": "Childrens programs"
			},
			{
				"key": "concierge-service",
				"display": "Concierge service"
			},
			{
				"key": "currency-exchange-on-site",
				"display": "Currency exchange on-site"
			},
			{
				"key": "laundry-service",
				"display": "Laundry service"
			},
			{
				"key": "meetingbanquet-facilities",
				"display": "Meeting/Banquet facilities"
			},
			{
				"key": "ski-shuttle-free",
				"display": "Ski shuttle (free)"
			},
			{
				"key": "ski-shuttle-surcharge",
				"display": "Ski shuttle (surcharge)"
			},
			{
				"key": "spa",
				"display": "Spa"
			},
			{
				"key": "train-station-shuttle",
				"display": "Train station shuttle"
			},
			{
				"key": "wedding-services",
				"display": "Wedding services"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./routes/hotels/components/features.json
// module id = 3141
// module chunks = 0